import React from "react";
import { Form } from "react-bootstrap";
import { ErrorMessage } from "formik";

export default function ParentTabFields({ values, handleChange }) {
  return (
    <>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            placeholder="Enter your first name"
            value={values.firstName}
            onChange={handleChange}
          />
          <ErrorMessage
            name="firstName"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            name="lastName"
            placeholder="Enter your last name"
            value={values.lastName}
            onChange={handleChange}
          />
          <ErrorMessage
            name="lastName"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            placeholder="Enter your email"
            value={values.email}
            disabled={true}
          />
          <ErrorMessage name="email" component="p" className="error-message" />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>Phone Number 1</Form.Label>
          <Form.Control
            type="tel"
            name="guardianPhone1"
            placeholder="Enter your phone number (+440123456789)"
            value={values.guardianPhone1}
            onChange={handleChange}
          />
          <ErrorMessage
            name="guardianPhone1"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Phone Number 2</Form.Label>
          <Form.Control
            type="tel"
            name="guardianPhone2"
            placeholder="Enter your phone number (+440123456789)"
            value={values.guardianPhone2}
            onChange={handleChange}
          />
          <ErrorMessage
            name="guardianPhone2"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>Street Address Line 1</Form.Label>
          <Form.Control
            type="text"
            name="guardianAddress1"
            placeholder="Enter your street address"
            value={values.guardianAddress1}
            onChange={handleChange}
          />
          <ErrorMessage
            name="guardianAddress1"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Street Address Line 2</Form.Label>
          <Form.Control
            type="text"
            name="guardianAddress2"
            placeholder="Enter your street address"
            value={values.guardianAddress2}
            onChange={handleChange}
          />
          <ErrorMessage
            name="guardianAddress2"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>City</Form.Label>
          <Form.Control
            type="text"
            name="guardianCity"
            placeholder="Enter your city"
            value={values.guardianCity}
            onChange={handleChange}
          />
          <ErrorMessage
            name="guardianCity"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 flex-grow-1">
          <Form.Label>Postcode</Form.Label>
          <Form.Control
            type="text"
            name="guardianPostcode"
            placeholder="Enter your postcode"
            value={values.guardianPostcode}
            onChange={handleChange}
          />
          <ErrorMessage
            name="guardianPostcode"
            component="p"
            className="error-message"
          />
        </div>
      </div>
    </>
  );
}
